export default __webpack_public_path__ + "static/media/stock-photo-cucumbers-removebg-preview.db3edbec.png";